/** Toggle HR features in the dashboard UI. Set to true when ready to roll out. */
export const FEATURES = {
  timeTracking: false,
  absenceRequests: false,
} as const
